import { render, staticRenderFns } from "./PlateColumnHoverCard.vue?vue&type=template&id=1f7720e6&scoped=true"
import script from "./PlateColumnHoverCard.vue?vue&type=script&lang=js"
export * from "./PlateColumnHoverCard.vue?vue&type=script&lang=js"
import style0 from "./PlateColumnHoverCard.vue?vue&type=style&index=0&id=1f7720e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7720e6",
  null
  
)

export default component.exports